import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { FormControl, Grid, MenuItem, Select } from "@mui/material"
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import BallotIcon from "@mui/icons-material/Ballot"

import { NavLink } from "react-router-dom"
import useStyles from "./useStyles"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../redux/actions/app"
import { useDispatch } from "react-redux"
import { helpGetOrganizationWithID } from "../../../app/services/Organization/helpGetOrganizationWithID"
import { updateSubscriberCorpEntities } from "../../../app/services/Suscriber/updateSubscriberCorpEntities"
import ModalConfirmChange from "../../../components/Modals/Organizations/User/ModalConfirmChange/ModalConfirmChange"
import { getSuscriberRefId } from "../../../app/services/Suscriber/getSuscriberFromRefId"

export default function StepperSeeDetailsSuscriber({
  setsuscriber,
  suscriber,
  statesSuscriber,
  setstateSubscriberStep,
  setLoading,
  countProducts,
  countUser,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [selectedStatusId, setSelectedStatusId] = React.useState(null)
  const [organizationCuit, setOrganizationCUIT] = React.useState(null)
  // return name of status suscriber with codeState
  const getName = (codeSuscriber) => {
    const state = statesSuscriber.filter(
      (x) => x.subscriber_status_id === codeSuscriber,
    )
    return state.length > 0 ? state[0].subscriber_status_desc : null
  }
  React.useEffect(() => {
    const loadOrganizationData = async () => {
      if (suscriber && suscriber.organization_id) {
        setLoading(true)
        await handleGetOrganizationWithID()
        setLoading(false)
      }
    }

    loadOrganizationData()
  }, [suscriber])
  // return date string of visual
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }

  const handleOpenModalChangeStatus = (newStatusId) => {
    setSelectedStatusId(newStatusId)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedStatusId(null)
  }
  const handleGetOrganizationWithID = async () => {
    try {
      const response = await helpGetOrganizationWithID(
        suscriber.organization_id,
      )

      setOrganizationCUIT(response.data?.data)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
    }
  }

  const handleConfirmChangeStatus = async () => {
    if (!organizationCuit) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar("Error: Datos de organización no disponibles."),
      )
      return
    }
    handleCloseModal()
    setLoading(true)
    const subscriberId = suscriber.subscriber_id
    try {
      const requestBody = {
        clicod: suscriber.subscriber_ref_id ?? "",
        subscriber_name: suscriber.subscriber_name ?? "",
        organization_cuit: organizationCuit.organizationCuit ?? "",
        organization_legal_name: suscriber.organization_legal_name ?? "",
        subscriber_max_user_count: suscriber.subscriber_max_user_count ?? "",
        subscriber_status_id: selectedStatusId,
      }


      await updateSubscriberCorpEntities(subscriberId, requestBody)

      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Estado actualizado correctamente."))

      await handleGetSuscriber()
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar("Ocurrió un error al actualizar el estado."),
      )
    } finally {
      setLoading(false)
    }
  }

  const handleGetSuscriber = async () => {
    try {
      const params = {
        clicod: suscriber.subscriber_ref_id,
      }
      const getsuscriber = await getSuscriberRefId(params)
      setsuscriber(getsuscriber.data)
      return getsuscriber
    } catch (err) {
      // error
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error. Intente nuevamente."))
      return "Error"
    }
  }
  const SeeMoreOrganizationOfID = () => {
    return (
      suscriber && (
        <>
          <Grid container sx={{ ml: 2, mt: 2, width: "90%" }}>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Nombre:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {suscriber.subscriber_name}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Numero de suscriptor:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {suscriber.subscriber_ref_id}
              </Typography>
            </Grid>
          </Grid>
          <Grid container sx={{ ml: 2, width: "90%" }}>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Estado:
              </Typography>
              {/* <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {getName(suscriber.subscriber_status_id)
                  ? getName(suscriber.subscriber_status_id)
                  : "- -"}
              </Typography> */}
              <FormControl style={{ minWidth: 160 }} className={classes.value}>
                <Select
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={suscriber.subscriber_status_id}
                  onChange={(e) => handleOpenModalChangeStatus(e.target.value)}
                  renderValue={(selectedId) => {
                    if (!selectedId) {
                      return <span style={{ color: "#aaa" }}>- -</span>
                    }
                    return getName(selectedId)
                  }}
                >
                  {statesSuscriber.map((state) => (
                    <MenuItem
                      key={state.subscriber_status_id}
                      value={state.subscriber_status_id}
                    >
                      {state.subscriber_status_desc}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {isModalOpen && (
              <ModalConfirmChange
                title="Confirmar cambio de estado"
                message={`¿Estás seguro de cambiar el estado del suscriptor?`}
                open={isModalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirmChangeStatus}
              />
            )}
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Máximo de usuarios:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {suscriber.subscriber_max_user_count}
              </Typography>
            </Grid>
          </Grid>

          <Grid container sx={{ ml: 2, width: "90%" }}>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Fecha de creación:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {formatDate(suscriber.creation_date)}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Usuario creador:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {suscriber.creation_user}
              </Typography>
            </Grid>
          </Grid>

          <Grid container sx={{ ml: 2, pt: 2, width: "90%" }}>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Fecha de modificación:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {formatDate(suscriber.modification_date)
                  ? formatDate(suscriber.modification_date)
                  : "- -"}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                Usuario modificador:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {suscriber.modification_user
                  ? suscriber.modification_user
                  : "- -"}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography
                sx={{
                  mt: 2,
                  mb: 1,
                  fontSize: 15,
                  color: "#1F2024",
                  fontWeight: "bold",
                }}
              >
                ID de suscriptor:
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#2F3D40" }}>
                {suscriber.subscriber_id || "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.gridContainerButtons}>
            <Grid item xs={12}>
              <div>
                <NavLink
                  to={`/subscribers/${suscriber.subscriber_id}/suscriptions`}
                  className={classes.button}
                >
                  <BallotIcon className={classes.iconsButton} />
                  <Typography className={classes.typographyButton}>
                    Ver suscripciones y productos{" "}
                    {countProducts && "(" + countProducts + ")"}
                  </Typography>
                </NavLink>
              </div>
              <div>
                <NavLink
                  to={`/subscribers/${suscriber.subscriber_ref_id}/users`}
                  className={classes.button}
                >
                  <PersonOutlineIcon className={classes.iconsButton} />
                  <Typography className={classes.typographyButton}>
                    Ver usuarios asociados {countUser && "(" + countUser + ")"}
                  </Typography>
                </NavLink>
              </div>

              {suscriber.organization_id && (
                <div>
                  <NavLink
                    to={`/subscribers/${suscriber.subscriber_ref_id}/organizations`}
                    className={classes.button}
                  >
                    <BusinessOutlinedIcon className={classes.iconsButton} />
                    <Typography className={classes.typographyButton}>
                      Ver organización asociada{" "}
                    </Typography>
                  </NavLink>
                </div>
              )}
            </Grid>
          </Grid>
        </>
      )
    )
  }

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            marginLeft: "5%",
            width: "90%",

            marginTop: "2%",
          }}
        >
          <Typography
            sx={{
              mt: 2,
              mb: 1,
              fontWeight: "bold",
              color: "#32332E",
              fontSize: 18,
            }}
          >
            Información del suscriptor
          </Typography>
          <SeeMoreOrganizationOfID />
        </Box>

        <ButtonClose setstateSubscriberStep={setstateSubscriberStep} />
      </Box>
    </>
  )
}

function ButtonClose({ setstateSubscriberStep }) {
  return (
    <Box
      style={{
        position: "absolute",
        width: "95%",
        marginLeft: "5%",
        bottom: 20,
        display: "flex",
      }}
    >
      <Box
        sx={{
          width: 90,
          height: 35,
          backgroundColor: "#1C846F",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
          WebkitBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
          MozBoxShadow: "0px 0px 5px 0px rgba(0,0,0,0.50)",
          borderRadius: 1,
          display: "flex",
          "&:hover": {
            bgcolor: "#1BF57F",
          },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          onClick={() => {
            setstateSubscriberStep(false)
          }}
          sx={{
            color: "#FFFFFF",
            cursor: "pointer",
            fontSize: 16,
          }}
        >
          Cerrar
        </Typography>
      </Box>
    </Box>
  )
}
